export default "__VITE_ASSET__w5dNfosT__"